import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import EnvelopeRows from "../../common/EnvelopeRows";
import HeaderWithTag from "../../common/header_with_tag";
import TryGetAgents from "./try";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": [
    {
      "agentId": "BAY",
      "branchId": "BAY",
      "city": "BAYDHABA",
      "country": "SOMALIA",
      "isoCode": "SO",
      "address": "624066666/624933333/621140000",
      "phone": "TEL 621112000/367006/624111555/621174444/625747266"
    }
  ]
}`;

function GetAgents() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Agents</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Agents
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Retrieve agents"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Common/GetAgentByCountry?countryCode=SO
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Returns agents available for payout or processing in the specified country code.
                        Use this to select the appropriate destination agent for a remittance.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Query Parameters"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>countryCode</td>
                                <td>string</td>
                                <td>ISO country code (e.g. SO)</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>2</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <EnvelopeRows />
                              <tr>
                                <td>data[].agentId</td>
                                <td>string</td>
                                <td>Agent identifier</td>
                              </tr>
                              <tr>
                                <td>data[].branchId</td>
                                <td>string</td>
                                <td>Branch identifier</td>
                              </tr>
                              <tr>
                                <td>data[].city</td>
                                <td>string</td>
                                <td>City name</td>
                              </tr>
                              <tr>
                                <td>data[].country</td>
                                <td>string</td>
                                <td>Country name</td>
                              </tr>
                              <tr>
                                <td>data[].isoCode</td>
                                <td>string</td>
                                <td>ISO country code</td>
                              </tr>
                              <tr>
                                <td>data[].address</td>
                                <td>string</td>
                                <td>Address details</td>
                              </tr>
                              <tr>
                                <td>data[].phone</td>
                                <td>string</td>
                                <td>Phone numbers</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryGetAgents
                    codeBlackTitle="Request Simple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetAgents;
